// Admission Letter for Matriculation System / AKU-EB — campus 1 & 2 (and the
// default/fallback template for any campus not on the O-Level letter).
import React from "react";
import { AdmissionData } from "../admission-list";

interface StandardAdmissionLetterContentProps {
  admissionData: AdmissionData;
  logoUrl: string;
  schoolName: string;
  schoolAddress: string;
  formattedDate: string;
}

const StandardAdmissionLetterContent: React.FC<
  StandardAdmissionLetterContentProps
> = ({ admissionData, logoUrl, schoolName, schoolAddress, formattedDate }) => {
  return (
    <div
      className="admission-letter printable-content"
      id="admission-letter-content"
    >
      {/* Header */}
      <div className="text-center mb-4">
        <div className="d-flex align-items-center justify-content-center mb-2">
          <img
            src={logoUrl}
            alt={schoolName}
            className="img-fluid"
            style={{
              width: "100px",
              height: "100px",
              marginRight: "15px",
              objectFit: "contain",
            }}
          />
          <div>
            <h1
              className="text-uppercase fw-bold mb-1"
              style={{
                fontSize: "24px",
                letterSpacing: "2px",
                color: "#2c3e50",
              }}
            >
              {schoolName}
            </h1>
            <p
              style={{
                fontSize: "13px",
                fontWeight: "bold",
                color: "#2c3e50",
                margin: "0",
                lineHeight: "1.3",
              }}
            >
              {schoolAddress}
            </p>
          </div>
        </div>

        <div className="border-top border-bottom py-2 my-3">
          <h2 className="mb-0" style={{ fontSize: "18px", color: "#34495e" }}>
            ADMISSION LETTER FOR (MATRICULATION SYSTEM/AKU-EB)
            <br />
            (2026-2027)
          </h2>
        </div>
      </div>

      {/* Date */}
      <div className="mb-4 text-end text-decoration-underline">
        <strong>Date: {formattedDate}</strong>
      </div>

      {/* Salutation */}
      <div className="mb-3">
        <strong>Dear Parents/Guardians,</strong>
      </div>

      {/* Congratulations Section */}
      <div className="mb-4">
        <p>
          Congratulations! Master/ Miss{" "}
          <strong className="text-decoration-underline">
            {admissionData.firstName} {admissionData.lastName}
          </strong>{" "}
          has been through the assessment, successfully for Class{" "}
          <strong className="text-decoration-underline">
            {admissionData.appliedClass.name}
          </strong>
          .
        </p>
      </div>

      {/* Steps Section */}
      <div className="mb-4">
        <p>
          Following are the steps to be taken for further proceeding the
          admission process.
        </p>
        <ol className="ps-3" style={{ listStyleType: "decimal" }}>
          <li className="mb-2">
            Kindly receive an admission form from the school reception and
            submit it according to the prescribed submission procedure and
            date.
          </li>
          <li className="mb-2">
            Worksheet pack amount will be communicated through WhatsApp group
            in July Once paid the worksheet packs will be issued to students
            in their classrooms.
          </li>
          <li className="mb-2">
            Fee card will be issued in the month of <strong>August</strong>.
            It is must to follow the fee schedule and rules given on the fee
            card.
          </li>
          <li className="mb-2">
            School Uniform is available at{" "}
            <strong>
              "MARIA &amp; HARIS School and College Uniform Shop#C-24, Yousuf
              Plaza, F.B. Area Block-16, Water Pump karachi"
            </strong>
            .
          </li>
          <li className="mb-2">
            Student should bring light refreshment along with water flask
            with them.
          </li>
          <li className="mb-2">
            Kindly write the name and class of your child on the books,
            copies, water flask, lunch box and winter jackets to avoid any
            loss.
          </li>
        </ol>
      </div>

      {/* Note Box */}
      <div className="mb-4 border p-2">
        <p>
          <strong>Note:</strong> The classes of new admission students
          (NURSERY – CLASS IX) shall start from 4<sup>th</sup> August 2026.
          Timings only for this day will be from 9:00 am to 11:00 am. Regular
          timings will be followed from 5<sup>th</sup> August 2026.
        </p>
      </div>

      {/* School Timings Table */}
      <div className="mb-4">
        <p className="mb-2">
          <strong>Following are the regular school timings:</strong>
        </p>
        <table className="table table-bordered" style={{ fontSize: "14px" }}>
          <thead className="table-light">
            <tr>
              <th>Classes</th>
              <th>Reporting Time</th>
              <th>Home Time: Monday To Thursday</th>
              <th>Home Time: Friday</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Nursery</td>
              <td>08:50 am</td>
              <td>12:30 pm</td>
              <td>12:15 pm</td>
            </tr>
            <tr>
              <td>KG I - CLASS - II</td>
              <td>08:00 am</td>
              <td>12:50 pm</td>
              <td>12:15 pm</td>
            </tr>
            <tr>
              <td>CLASS III - CLASS IX</td>
              <td>08:00 am</td>
              <td>01:50 pm</td>
              <td>12:30 pm</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Closing */}
      <div className="text-center mb-4">
        <p className="mb-2">
          We warmly welcome you at {schoolName}. May you experience
          quality education and conducive environment.
        </p>
      </div>

      {/* Signature */}
      <div className="row mt-5">
        <div className="col-12 text-center">
          <p
            className="mb-1 border-top pt-2"
            style={{ width: "200px", margin: "0 auto" }}
          >
            <strong>Sincerely,</strong>
          </p>
          <p className="mb-0">
            <strong>Mrs. Hina Arsalan</strong>
          </p>
          <p className="mb-0">
            <em>Chief Executive</em>
          </p>
        </div>
      </div>

      {/* Footer campus strip */}
      <div className="mt-4 pt-3 border-top">
        <div className="row text-center" style={{ fontSize: "11px" }}>
          <div className="col-4">
            <strong>INCHOLI CAMPUS</strong>
            <br />
            C-10 Block 20 F.B. Area Karachi
            <br />
            Ph: 021-36344548
          </div>
          <div className="col-4">
            <strong>NORTH NAZIMABAD CAMPUS</strong>
            <br />
            D-31 Block B N. Nazimabad Karachi.
            <br />
            Ph:021-36670852
          </div>
          <div className="col-4">
            <strong>O'LEVEL NASEERABAD CAMPUS</strong>
            <br />
            C-3 Block 13 F.B. Area Karachi.
            <br />
            Ph: 021-36800252
          </div>
        </div>
      </div>
    </div>
  );
};

export default StandardAdmissionLetterContent;
